import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation, Autoplay, FreeMode } from "swiper";
import "swiper/swiper-bundle.css";
import "../../styles.css";
import "swiper/swiper.min.css";

export const SimpleCarouselComponent = ({
  children,
  slidesPerView = 1,
  autoplay = false,
  autoplayDelay = 4000,
  pagination = false,
  navigation = false,
  freeMode = false,
  vertical = false,
  classname = "carouselContainer",
  spaceBetween = 0,
  speed = 0,
}) => {
  const props = {
    slidesPerView: slidesPerView,
    loop: true,
    spaceBetween: spaceBetween,
    speed: speed,
  };
  const modules = [];
  if (autoplay) {
    props["autoplay"] = {
      delay: autoplayDelay,
      disableOnInteraction: false,
    };
    modules.push(Autoplay);
  }
  if (navigation) {
    props["navigation"] = true;
    modules.push(Navigation);
  }
  if (pagination) {
    props["pagination"] = {
      clickable: true,
    };
    modules.push(Pagination);
  }
  if (freeMode) {
    props["freeMode"] = true;
    modules.push(FreeMode);
  }
  if (vertical) {
    props["direction"] = "vertical";
  }
  return (
    <>
      <Swiper {...props} modules={modules} className={classname}>
        {children}
      </Swiper>
    </>
  );
};
